import {
  MESSAGE_LOAD,
  MESSAGE_LOAD_SUCCESS,
  MESSAGE_ERROR,
  MESSAGE_CLEAN
} from "./actionTypes"

export const messageError = error => {
  return {
    type: MESSAGE_ERROR,
    payload: error,
  }
}
export const initLoadMessage = (filter) => {
  return {
    type: MESSAGE_LOAD,
    payload: filter,
  }
}

export const loadMessages = types => {

  types.forEach(c => {
    c.label = c.name
    c.text = c.value
    c.value = c.code
  })

  return {
    type: MESSAGE_LOAD_SUCCESS,
    payload: types,
  }
}

export const cleanMessages = () => {
  return {
    type: MESSAGE_CLEAN,
    payload: {},
  }
}

